export default __webpack_public_path__ + "static/media/images/rpcb2.00b9e63b.png";